export default class Response {
    statusCode;
    data;
}